import { render, staticRenderFns } from "./TeamOnDuty.vue?vue&type=template&id=6cf9b153&scoped=true&"
import script from "./TeamOnDuty.vue?vue&type=script&lang=ts&"
export * from "./TeamOnDuty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf9b153",
  null
  
)

export default component.exports